import { CDT, CST } from '@/scripts/constants/promos'
import { WcsPromotion } from '@/scripts/interfaces/normalizer'
import { getBestBetweenTwoPromos, sortPromos } from '../sort-promos'
import RbDate from '@/utils/rb-date'
import moment from 'moment'
export class WcsPromotions {
  static sanitizeDate = (date = '') => {
    if (!date) {
      return date
    }
    const formattedDate = date.replace(/-/g, '/')
    const isDateDaylightSavingTime = RbDate.isDST(new Date(formattedDate)) //RbDate.isDateDaylightSavingTime(formattedDate)
    return isDateDaylightSavingTime ? formattedDate : formattedDate.replace(CDT, CST)
  }

  static isPromotionStarted = (startDateTimestamp: number) => {
    if (!startDateTimestamp) return false

    const now = RbDate.getTimeDate()
    return startDateTimestamp < now
  }

  static isPromotionEnded = (endDateTimestamp: number) => {
    if (!endDateTimestamp) return false

    const now = RbDate.getTimeDate()
    return endDateTimestamp < now
  }

  static isPromotionInProgress = (startDateTimestamp: number, endDateTimestamp: number) => {
    if (!startDateTimestamp || !endDateTimestamp) return false

    return (
      WcsPromotions.isPromotionStarted(startDateTimestamp) &&
      !WcsPromotions.isPromotionEnded(endDateTimestamp)
    )
  }

  static calculatePromotionInProgress(
    promotions: Array<WcsPromotion>,
    bypassUserSegmentFilter = false
  ) {
    let sortedPromotions = sortPromos(promotions, bypassUserSegmentFilter)
    let currentPromotion = getBestBetweenTwoPromos(sortedPromotions)

    if (sortPromos(promotions, bypassUserSegmentFilter).length === 0) {
      return {}
    } else {
      sortedPromotions = sortPromos(promotions, bypassUserSegmentFilter)
      currentPromotion = getBestBetweenTwoPromos(sortedPromotions)

      const isPromoinProgress = WcsPromotions.isPromotionInProgress(
        currentPromotion.startDate,
        currentPromotion.endDate
      )
      if (isPromoinProgress) {
        return currentPromotion
      }

      const isPromoEnded = WcsPromotions.isPromotionEnded(currentPromotion.endDate)
      if (isPromoEnded) {
        return {}
      }
    }
    return {}
  }
}
